module.exports = __webpack_public_path__ + "img/caixabank.9f98cdd8.png";